import { render } from "./ArticleImageLeft.vue?vue&type=template&id=6858cc41&scoped=true"
import script from "./ArticleImageLeft.vue?vue&type=script&lang=js"
export * from "./ArticleImageLeft.vue?vue&type=script&lang=js"

import "./ArticleImageLeft.vue?vue&type=style&index=0&id=6858cc41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6858cc41"]])

export default __exports__